/**
 * Parking lot "Rates, height and payment" modal.
 *
 * Centered, dimmed background, visible "×" close, closes on outside click
 * or Escape, scrolls internally if content is taller than the viewport.
 */
document.addEventListener('DOMContentLoaded', function () {
    var openModal = null;

    function close() {
        if (!openModal) {
            return;
        }
        openModal.classList.remove('is-open');
        openModal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('lot-rates-modal-open');
        openModal = null;
    }

    function open(modal) {
        if (openModal) {
            close();
        }
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('lot-rates-modal-open');
        openModal = modal;
    }

    document.querySelectorAll('[data-modal-target]').forEach(function (trigger) {
        var modal = document.querySelector(trigger.getAttribute('data-modal-target'));
        if (!modal) {
            return;
        }
        trigger.addEventListener('click', function () {
            open(modal);
        });
    });

    document.querySelectorAll('[data-modal-close]').forEach(function (closer) {
        closer.addEventListener('click', close);
    });

    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
            close();
        }
    });
});
